import React from 'react';
import styled from 'styled-components';
import { CardBodyItemLoadingUI } from './cardBodyItemLoadingUI';
import { CardTitleLoadingUI } from './cardTitleLoadingUI';
import { DayCardHourlyLinkLoadingUI } from './dayCardHourlyLinkLoadingUI';

interface LargeDayForecastCardLoadingUIProps {
    shouldDisplayHourlyLink: boolean;
}

export const LargeDayForecastCardLoadingUI = ({ shouldDisplayHourlyLink = true }: LargeDayForecastCardLoadingUIProps) => {
    return (
        <Container shouldDisplayHourlyLink={shouldDisplayHourlyLink}>
            <SectionsWrapper>
                <CardTitleBodyGroup>
                    <CardTitleLoadingUI />
                    <CardBodyItemLoadingUI key='card-item-day-section' isDayItem={true} />
                    <CardBodyItemLoadingUI key='card-item-night-section' isDayItem={false} />
                </CardTitleBodyGroup>
                {
                    shouldDisplayHourlyLink && <DayCardHourlyLinkLoadingUI  />
                }
            </SectionsWrapper>
        </Container>
    );
};

const SectionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 184px;
    height: 100%;
`;

const CardTitleBodyGroup = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    cursor: pointer;
`;

interface ContainerProps {
    shouldDisplayHourlyLink: boolean;
}

const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-width: 184px;
    width: auto;
    height: ${({ shouldDisplayHourlyLink }) => shouldDisplayHourlyLink ? '247px' : '216px'};
    max-height: 247px;
`;
